import { IFilter, IFilterOption } from '../../interfaces/Filter.interfaces';
import { filterSliderConstant } from './slider/filterSliderConstant';

export interface IUserOwnTractorFilterOption extends IFilterOption {
  value: UserOwnTractorFilterOptionValueType;
}

export type userOwnTractorFilterKeyType = 'sorter' | 'filter_brand' | 'filter_region' | 'engineOutputInPs';

export interface IUserOwnTractorFilter extends IFilter {
  key: userOwnTractorFilterKeyType;
  options: IUserOwnTractorFilterOption[];
}

export enum UserOwnTractorFilterOptionValueSorterEnum {
  default_desc = 'default_desc',
  registeredAt_desc = 'registeredAt_desc',
  pokeCount_desc = 'pokeCount_desc',
  manufacturedYear_desc = 'manufacturedYear_desc',
  operationTime_asc = 'operationTime_asc',
}

export enum UserOwnTractorFilterOptionValueRegionEnum {
  seoul = 'seoul',
  gyeonggi = 'gyeonggi',
  incheon = 'incheon',
  daejeon = 'daejeon',
  sejong = 'sejong',
  chungnam = 'chungnam',
  chungbuk = 'chungbuk',
  gangwon = 'gangwon',
  busan = 'busan',
  daegu = 'daegu',
  ulsan = 'ulsan',
  gyeongnam = 'gyeongnam',
  gyeongbuk = 'gyeongbuk',
  gwangju = 'gwangju',
  jeonnam = 'jeonnam',
  jeonbuk = 'jeonbuk',
  jeju = 'jeju',
}

type UserOwnTractorFilterOptionValueType =
  | UserOwnTractorFilterOptionValueSorterEnum
  | UserOwnTractorFilterOptionValueRegionEnum
  | string
  | number;

const userOwnTractorFilterSorterConstant: IUserOwnTractorFilter = {
  key: 'sorter',
  title: '정렬',
  optionType: 'radio',
  options: [
    {
      optionName: '기본 정렬순',
      value: UserOwnTractorFilterOptionValueSorterEnum.default_desc,
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '날짜순',
      value: UserOwnTractorFilterOptionValueSorterEnum.registeredAt_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '인기순',
      value: UserOwnTractorFilterOptionValueSorterEnum.pokeCount_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '연식순',
      value: UserOwnTractorFilterOptionValueSorterEnum.manufacturedYear_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '사용시간순',
      value: UserOwnTractorFilterOptionValueSorterEnum.operationTime_asc,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const userOwnTractorFilterRegionConstant: IUserOwnTractorFilter = {
  key: 'filter_region',
  title: '지역',
  buttonTitle: '지역으로 보기',
  optionType: 'checkbox',
  options: [
    {
      optionName: '서울',
      value: UserOwnTractorFilterOptionValueRegionEnum.seoul,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '경기',
      value: UserOwnTractorFilterOptionValueRegionEnum.gyeonggi,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '인천',
      value: UserOwnTractorFilterOptionValueRegionEnum.incheon,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '대전',
      value: UserOwnTractorFilterOptionValueRegionEnum.daejeon,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '세종',
      value: UserOwnTractorFilterOptionValueRegionEnum.sejong,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '충남',
      value: UserOwnTractorFilterOptionValueRegionEnum.chungnam,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '충북',
      value: UserOwnTractorFilterOptionValueRegionEnum.chungbuk,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '강원',
      value: UserOwnTractorFilterOptionValueRegionEnum.gangwon,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '부산',
      value: UserOwnTractorFilterOptionValueRegionEnum.busan,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '대구',
      value: UserOwnTractorFilterOptionValueRegionEnum.daegu,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '울산',
      value: UserOwnTractorFilterOptionValueRegionEnum.ulsan,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '경남',
      value: UserOwnTractorFilterOptionValueRegionEnum.gyeongnam,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '경북',
      value: UserOwnTractorFilterOptionValueRegionEnum.gyeongbuk,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '광주',
      value: UserOwnTractorFilterOptionValueRegionEnum.gwangju,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '전남',
      value: UserOwnTractorFilterOptionValueRegionEnum.jeonnam,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '전북',
      value: UserOwnTractorFilterOptionValueRegionEnum.jeonbuk,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '제주',
      value: UserOwnTractorFilterOptionValueRegionEnum.jeju,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const userOwnTractorFilterEngineOutputInPsConstant: IUserOwnTractorFilter = {
  key: 'engineOutputInPs',
  title: '마력',
  buttonTitle: '마력으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.engineOutputInPs.min,
      defaultValue: filterSliderConstant.engineOutputInPs.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.engineOutputInPs.max,
      defaultValue: filterSliderConstant.engineOutputInPs.max,
      isSelected: true,
    },
  ],
};

const userOwnTractorFilterBrandConstant: IUserOwnTractorFilter = {
  key: 'filter_brand',
  title: '브랜드',
  buttonTitle: '브랜드로 보기',
  optionType: 'checkbox',
  options: [],
};

export const userOwnTractorFiltersConstant: IUserOwnTractorFilter[] = [
  userOwnTractorFilterSorterConstant,
  userOwnTractorFilterBrandConstant,
  userOwnTractorFilterEngineOutputInPsConstant,
  userOwnTractorFilterRegionConstant,
];
